// extracted by mini-css-extract-plugin
export default {"group":"result-item-group_group__lxfH1"};